// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1rApX","colMin":"styles_colMin__1w8nz","colCheckbox":"styles_colCheckbox__3xMiV"};